// ─────────────────────────────────────────────
//  FollowUpBanner — provider-handoff strip on a room card (Phase 5.2).
//  Two variants driven by the room's `followUp` field (NEVER a status):
//    • following — origin room: "→ Following to Room X" (navy, solid border)
//    • awaiting  — destination: "⏳ Awaiting arrival from Room Y" (navy,
//      dashed border = the standby look). STATIC by design — blink/pulse is
//      reserved for true alerts; a handoff is informational.
//  Full-width strip positioned like RoomCard's reliefPending banner.
// ─────────────────────────────────────────────
import React from "react";
import { followUpVariant } from "../domain/conditions";
import tokens from "../theme/tokens";

const { color, font, radius } = tokens;

export default function FollowUpBanner({ followUp }) {
  const variant = followUpVariant(followUp);
  if (!variant) return null;
  const isAwaiting = variant === "awaiting";
  const who = followUp.providerName || "Provider";
  const text = isAwaiting
    ? `⏳ Awaiting arrival${followUp.fromRoomName ? ` from ${followUp.fromRoomName}` : ""} — ${who}`
    : `→ Following to ${followUp.toRoomName || "another room"} — ${who}`;
  return (
    <div
      style={{
        marginTop: 6,
        padding: "4px 8px",
        borderRadius: radius.sm,
        background: "#e8edf9",
        border: `1px ${isAwaiting ? "dashed" : "solid"} ${color.accent.primary}`,
        color: color.accent.primary,
        fontSize: font.size.label,
        fontWeight: font.weight.bold,
        lineHeight: 1.3,
        textAlign: "center",
      }}
    >
      {text}
    </div>
  );
}
